import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, of, throwError, lastValueFrom, BehaviorSubject } from 'rxjs';
import { delay, catchError, tap, map, switchMap } from 'rxjs/operators';
import { TokenService } from "./token.service";
import { environment } from "../environments/environment";
import { EncryptionService } from '../app/services/encryption.service';


@Injectable({
  providedIn: 'root'
})
export class AuthService {
  environment: any = environment;

  // HTTP_OPTIONS = {
  //   headers: new HttpHeaders({
  //     'Content-Type': 'application/json',
  //     'Authorization': `Bearer ${this.tokenService.getsessionToken("token")}`
  //   })
  // };


  HTTP_OPTIONS = {
    headers: new HttpHeaders({
      'Content-Type': "application/json",
      // Authorization: 'Bearer ' + btoa(this.APIConstants.OAUTH_CLIENT + ':' + this.APIConstants.OAUTH_SECRET)
    })
  };

  constructor(private http: HttpClient,
    private tokenService: TokenService,
    private router: Router,
    private encryptionService: EncryptionService
  ) {

  }

  private static handleError(error: HttpErrorResponse): any {
    if (error.error instanceof ErrorEvent) {
      console.error('An error occurred:', error.error.message);
    } else {
      console.error('Backend returned code ', error.status, 'body was: ', error.error);
    }
    var errMessage = 'Something bad happened; please try again later.';
    if (error.error && error.error.msg) {
      errMessage = error.error.msg;
    } else {
      if (error.error && error.error.message) {
        errMessage = error.error.message;
      }
    }
    return throwError(errMessage);
  }

  login(payload: any): Observable<any> {

    this.tokenService.removeToken();
    this.tokenService.removeRefreshToken();
    return this.http.post<any>(this.environment.API_URL + '/auth/login/', payload, this.HTTP_OPTIONS).pipe(
      tap(res => {

      }),
      catchError((error: HttpErrorResponse) => {
        // Handle the error and log the status code
        console.error('Error status:', error.status);
        console.error('Error body:', error.error);

        // Optionally, you can rethrow the error or return a default value
        return throwError(() => error);  // Re-throws the error
      }));
  }

  login_normal(username: string, password: string, userType: any, force_login: boolean): Observable<any> {

    this.tokenService.removeToken();
    this.tokenService.removeRefreshToken();
    let body = {
      "password": password,
      "username": username,
      "force_login": force_login,
      "app_name": userType == 'Dealer' ? this.environment.CRM_APP_NAME : this.environment.GDC_APP_NAME
    };
    //console.log('body - ', body);
    return this.http.post<any>(this.environment.API_URL + '/auth/login/', body, this.HTTP_OPTIONS).pipe(
      tap(res => {
        if (res.hasOwnProperty('token')) {
          this.tokenService.saveToken(res['token'].access_token);
          this.tokenService.saveRefreshToken(res['token'].refresh_token);
        }
      }),
      catchError((error: HttpErrorResponse) => {
        // Handle the error and log the status code
        console.error('Error status:', error.status);
        console.error('Error body:', error.error);

        // Optionally, you can rethrow the error or return a default value
        return throwError(() => error);  // Re-throws the error
      }));
  }


  loginToDealer(token: string, vas_opty_id?: string, pos_id?: string): Observable<any> {

    this.tokenService.removeToken();
    this.tokenService.removeRefreshToken();
    let body = {
      "handle": token,
      vas_opty_id: vas_opty_id ? vas_opty_id : null,
      pos_id: pos_id ? pos_id : null,
      "app_name": this.environment.CRM_APP_NAME
    };
    //console.log('body - ', body);
    return this.http.post<any>(this.environment.API_URL + '/auth/fv/identity/process/', body, this.HTTP_OPTIONS).pipe(
      tap(res => {

      }),
      catchError((error: HttpErrorResponse) => {
        // Handle the error and log the status code
        console.error('Error status:', error.status);
        console.error('Error body:', error.error);

        // Optionally, you can rethrow the error or return a default value
        return throwError(() => error);  // Re-throws the error
      }));
  }




  logout(): void {
    // console.log('logout');
    const logoutUrl = `${this.environment.API_URL}/auth/logout/`;
    // console.log('logoutUrl - ',logoutUrl)

    this.http.post(logoutUrl, {}, this.HTTP_OPTIONS).pipe(
      tap((res) => {
        //console.log('auth service - ', res);
        // localStorage.removeItem('dealer_code');
        localStorage.removeItem('token');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('user_type');
        localStorage.removeItem('isLogin');
        localStorage.removeItem('username');
        localStorage.removeItem('position_type');
        localStorage.removeItem('fconfig');
        this.tokenService.clearToken();
        localStorage.clear();
        this.router.navigate(['login']); // Uncomment to redirect to login page
      }),
      catchError((error) => {
        console.error('Logout failed', error);
        return throwError(error);
      })
    ).subscribe((response) => {
      // console.log(response);
    });
  }


  getJsonData(username: any): Observable<any> {
    const normalizedUsername = username.toLowerCase();

    if (normalizedUsername == 'admin') {
      return this.http.get('/assets/sampleJson/login-admin.json');
    }
    else {
      return this.http.get('/assets/sampleJson/login-dealer.json');
    }
  }
  async checkNRefreshToken() {
    const refreshToken: any = this.tokenService.getsessionToken("refreshToken");
    //console.log('refreshToken 19 aug- ', refreshToken);

    const body = {
      refresh_token: refreshToken
    };
    try {
      const response = await this.http.post<any>(`${environment.API_URL}${environment.GETTOKEN}`, body).pipe(
        map(response => {
          // console.log('rs - ', response);

          if (response?.error_code === 8 || response?.error_code === 9) {
            // console.log('Call the logout function if error_code is 8 or 9');
            if (response?.msg == 'Refresh token is expired.') {
              this.tokenService.clearToken();
              localStorage.clear();
              this.router.navigate(['/login']); // Uncomment to redirect to login page
            }
            else {
              this.tokenService.clearToken();
              localStorage.clear();
              this.router.navigate(['/login']); // Uncomment to redirect to login page
            }
            return null;
          }
          return response.data;  // Access the `data` object containing tokens
        }),
        catchError(error => {
          console.error('Error refreshing token', error);
          return throwError(error);
        })
      ).toPromise();

      return response;
    } catch (error: any) {
      //console.error('Error in checkNRefreshToken', error);
      //console.error('Error in checkNRefreshToken', error.name);

      if (error?.error.msg == 'Refresh token is expired.') {
        this.tokenService.clearToken();
        localStorage.clear();
        this.router.navigate(['/login']);
      } else {
        // this.logout();
        // return null;
        this.tokenService.clearToken();
        localStorage.clear();
        this.router.navigate(['/login']);
      }
    }
  }
  async checkValidateToken() {
    // console.log('Validating token - checkValidateToken')
    const appName: any = this.tokenService.getsessionToken('appName');
    if (this.tokenService.getsessionToken("token") != null || this.tokenService.getsessionToken("token") != undefined) {
      const refreshTokenResponse: any = await this.checkNRefreshToken();
      //console.log('hi--------------', refreshTokenResponse);

      if (refreshTokenResponse?.access_token) {
        this.tokenService.saveToken(refreshTokenResponse.access_token);
        this.tokenService.saveRefreshToken(refreshTokenResponse.refresh_token);
        window.location.reload();
      }
      return true;
    } else {
      // console.log('hi--------------');
      this.sessionexpiredLogin();
      return false;
    }
  }
  sessionexpiredLogin() {
    this.tokenService.removeToken();
    this.tokenService.removeRefreshToken();
    this.router.navigate(["/login"]);
  }

  CheckTokenValidorNot(): Observable<any> {
    const refreshToken: any = this.tokenService.getsessionToken("refreshToken");
    const body = {
      refresh_token: refreshToken
    };
    // const response = await this.http.post<any>(`${environment.API_URL}${environment.GETTOKEN}`, body).pipe(
    //   map(response => {
    return this.http
      .post(`${environment.API_URL}${environment.GETTOKEN}`, body)
      .pipe(catchError(AuthService.handleError));
  }
  getUserRoleType() {
    // console.log('User Role - login service called');
    let roleType: any = this.encryptionService.getFromLocalStorage('user_type');
    return roleType;
  }

 

}
